module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-bold",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.prompt')))]), _vm._v(" "), _c('div', {
    staticClass: "k6-box"
  }, [_c('form', {
    staticClass: "slika",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "k6-profile-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.profilePhoto,
      "alt": "Profile image"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "image-upload",
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (!_vm.uid) ? _c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickPhotoUpload($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("pages.profile.userpicture.change")) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "k6-profile-data"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('h3', {
    staticClass: "text-bold k6-form-segment-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.userData")))]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.username')) + ":")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "disabled": ""
    },
    domProps: {
      "value": _vm.profile.username
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.name')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.firstName),
      expression: "profile.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstName"
    },
    domProps: {
      "value": (_vm.profile.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.surname')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.lastName),
      expression: "profile.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastName"
    },
    domProps: {
      "value": (_vm.profile.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.email')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "studentId"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.studentId')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.studentId),
      expression: "profile.studentId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "studentId"
    },
    domProps: {
      "value": (_vm.profile.studentId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "studentId", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.uid && this.rolesSelected.length == 0) ? _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "align-items": "flex-start"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admit),
      expression: "admit"
    }],
    staticStyle: {
      "transform": "scale(1.3)",
      "margin-top": "3px"
    },
    attrs: {
      "type": "checkbox",
      "disabled": _vm.uid
    },
    domProps: {
      "checked": Array.isArray(_vm.admit) ? _vm._i(_vm.admit, null) > -1 : (_vm.admit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.admit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.admit = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.admit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.admit = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.adminAdmit")))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "width": "fit-content"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfile($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.save")))])])])]), _vm._v(" "), (!_vm.uid) ? _c('div', {
    staticClass: "segment"
  }, [_c('h3', {
    staticClass: "text-bold k6-form-segment-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changepassword.userPassword")))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changepassword.oldPass")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "oldPassword"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changepassword.newPass")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "newPassword"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label', {
    attrs: {
      "for": "oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changepassword.repeatNewPass")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatNewPassword),
      expression: "repeatNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "repeatNewPassword"
    },
    domProps: {
      "value": (_vm.repeatNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatNewPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "width": "fit-content"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePassword($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changepassword.change")))])])])]) : _vm._e(), _vm._v(" "), (_vm.uid) ? _c('div', {
    staticClass: "segment"
  }, [_c('h3', {
    staticClass: "text-bold k6-form-segment-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.profile.changeroles.changeRole")))]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_vm._l((_vm.roleList), function(role) {
    return _c('div', [_c('div', {
      staticClass: "k6-form-row"
    }, [_c('label'), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rolesSelected),
        expression: "rolesSelected"
      }],
      staticStyle: {
        "transform": "scale(1.3)",
        "margin-top": "3px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": role.id,
        "checked": Array.isArray(_vm.rolesSelected) ? _vm._i(_vm.rolesSelected, role.id) > -1 : (_vm.rolesSelected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.rolesSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = role.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.rolesSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.rolesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.rolesSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(role.displayName))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "k6-form-row"
  }, [_c('label'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "width": "fit-content"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateRoles($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("pages.profile.changeroles.changeRoleButton")) + "\n            ")])])], 2)]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-feb79af6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-feb79af6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ProfileEdit.vue
// module id = 1479
// module chunks = 1